import React from 'react';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import {Fieldset} from "primereact/fieldset";
import DataTable from "../../shared/component/dataTable/DataTable";
import PurchaseOrderColumn from "../../shared/component/dataTable/columns/PurchaseOrderColumn.json";
import Dialog from "../../shared/component/dialog/Dialog";
import {Button, Col, Label, Row} from "reactstrap";
import PurchaseOrderItem from "./PurchaseOrderItem";
import Translate from "../../shared/language/Translate";


export default class PurchaseOrder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        this.refreshDataTable();
    }

    render() {
        return (<div>
            <AvForm>
                {false && this.renderFilter()}
                {this.purchaseOrderList()}
            </AvForm>
        </div>);
    }

    closeDisplayDialogFilter = () => {
        this.setState({displayDialogFilter: false});
    }

    onDataSelectFilter = (data) => {
        this.setState({displayDialogFilter: false});
    }

    renderFilter() {
        return (<div><Row>


        </Row>

        </div>)
    }

    purchaseOrderList() {
        return (
            <div>
                <Fieldset legend="Purchase Order">

                    <Button color="outline-primary" style={{marginBottom: '5px'}} onClick={() => {
                        this.setState({displayDialog: true});
                    }}>
                        <Translate contentKey="entity.action.add">Add</Translate>
                    </Button>

                    <DataTable ref={(elem) => this.refDataTable = elem} fields={PurchaseOrderColumn.fields}
                               objectName={PurchaseOrderColumn.name}
                               dataURL="inventory/purchaseOrder/all"
                               rows={10}
                               selectionMode="single" onDataSelect={this.onDataSelect}
                               loading={this.state.loading}/>


                    <Dialog visible={this.state.displayDialog}
                            header={"Purchase Order Items"}
                            onHide={() => this.setState({displayDialog: false})}
                            style={{width: '60vw', height: '35vw'}}>

                        <PurchaseOrderItem
                            refreshDataTable={this.refreshDataTable} ref={(elem) => this.refModelSave = elem}
                            closeDisplayDialog={this.closeDisplayDialog}

                        />
                    </Dialog>

                </Fieldset>
            </div>)
    }


    refreshDataTable = () => {
        this.closeDisplayDialog();
        this.refDataTable.refresh();
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
    }

    onDataSelect = (data) => {
        this.refModelSave.setData(Object.assign({}, data));

        this.setState({
            displayDialog: true,
        });

    }


    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let purchaseOrder = this.state.purchaseOrder;
        purchaseOrder[e.target.name] = value;
        this.setState({purchaseOrder: purchaseOrder});
    }

}

